export const JOURS = [
  { value: "lundi", label: "Lundi", court: "Lun" },
  { value: "mardi", label: "Mardi", court: "Mar" },
  { value: "mercredi", label: "Mercredi", court: "Mer" },
  { value: "jeudi", label: "Jeudi", court: "Jeu" },
  { value: "vendredi", label: "Vendredi", court: "Ven" },
  { value: "samedi", label: "Samedi", court: "Sam" },
  { value: "dimanche", label: "Dimanche", court: "Dim" },
];

// jours_semaine est stocké en texte JSON : '["lundi","mercredi"]'
export const parseJours = (value) => {
  if (Array.isArray(value)) return value;
  try {
    const jours = JSON.parse(value || "[]");
    return Array.isArray(jours) ? jours : [];
  } catch {
    return [];
  }
};

export const trierJours = (jours) =>
  JOURS.map((j) => j.value).filter((v) => jours.includes(v));

// "18:00:00" → "18h00"
export const formatHeure = (heure) => {
  if (!heure) return "";
  const [h, m] = heure.split(":");
  return `${h}h${m || "00"}`;
};

// { jours_semaine: ["lundi","mercredi"], heure_cours: "18:00:00" } → "Tous les Lundi, Mercredi à 18h00"
export const formatPlanning = (cours) => {
  if (!cours) return "";
  const jours = trierJours(parseJours(cours.jours_semaine))
    .map((v) => JOURS.find((j) => j.value === v).label)
    .join(", ");
  const heure = formatHeure(cours.heure_cours);
  if (jours && heure) return `Tous les ${jours} à ${heure}`;
  if (jours) return `Tous les ${jours}`;
  return heure ? `À ${heure}` : "";
};
